export default async function fetchPersonalByDependenciaYEstatusUsecase(repository, idDependencia, estatus) {
  const personal = await repository.fetchPersonalByDependenciaYEstatus(idDependencia, estatus)

  const remapedPersonal = personal.map((item) => {
    const catPuestoDependencia = Array.isArray(item.CatPuestoDependencia)
      ? item.CatPuestoDependencia[0]
      : item.CatPuestoDependencia

    const catPuesto = Array.isArray(catPuestoDependencia?.catPuesto)
      ? catPuestoDependencia.catPuesto[0]
      : catPuestoDependencia?.catPuesto

    return {
      ...item,
      idPersonal: item.id_personal,
      puesto: catPuesto?.puesto ?? 'N/A',
      idPuestoDependencia: catPuestoDependencia?.id ?? null,
      CatPuestoDependencia: catPuestoDependencia
        ? {
            ...catPuestoDependencia,
            catPuesto,
          }
        : null,
    }
  })

  return remapedPersonal
}
